import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withKeys as _withKeys, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/exit-browser.png'


const _withScopeId = n => (_pushScopeId("data-v-9dc625c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onKeyup"]
const _hoisted_2 = { class: "details" }
const _hoisted_3 = { class: "setting" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Infinite Fates", -1))
const _hoisted_5 = { class: "setting" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Roll", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Normally", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "5" }, "Only 5-star items", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "4" }, "Only 4- and 5-star items", -1))
const _hoisted_10 = [
  _hoisted_7,
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = { class: "setting" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Win 50/50", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Normally", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "1" }, "Always", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "0" }, "Never", -1))
const _hoisted_16 = [
  _hoisted_13,
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = { class: "setting" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Unlimited history scrolling", -1))
const _hoisted_19 = { class: "setting" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Show banner pity in history", -1))
const _hoisted_21 = { class: "setting" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Export "),
  /*#__PURE__*/_createElementVNode("a", { href: "https://paimon.moe" }, "paimon.moe"),
  /*#__PURE__*/_createTextVNode(" wish data")
], -1))
const _hoisted_23 = ["href"]
const _hoisted_24 = { class: "setting vertical" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Active banners", -1))
const _hoisted_26 = { class: "center" }

import Paimon from "@/state/PaimonMoe";
import { computed, ref } from "vue";
import { useStore } from "vuex";
import CancelConfirmButton from "../shared/CancelConfirmButton.vue";
import MultiSelect from "@/components/shared/MultiSelect.vue";
import { banners } from "@/state/Banners";
import { ItemDatabase } from "@/state/Gacha";


export default /*#__PURE__*/_defineComponent({
  emits: ["exit"],
  setup(__props, { emit }) {

const bannerOptions = Object.values(banners).map((banner) => ({
  id: banner.id,
  label: `${banner.id} (${
    ItemDatabase[banner.featuredDrops[0]]?.name ?? "no featured"
  })`,
}));

const $store = useStore();


const settings = ref({
  infinitePrimos: $store.state.settings.infinitePrimos,
  rollOnly: "" + ($store.state.settings.rollOnly ?? ""),
  winGuarantee: "" + ($store.state.settings.winGuarantee ?? ""),
  unlimitedHistoryScroll: $store.state.settings.unlimitedHistoryScroll,
  showBannerPity: $store.state.settings.showBannerPity,
});
const showConfirmReset = ref(false);
const paimon = Paimon.export();

const paimonExportJson = computed(
  () => `data:application/json;charset=utf-8,${encodeURIComponent(paimon)}`
);

function exit() {
  const newSettings = {
    infinitePrimos: settings.value.infinitePrimos,
    rollOnly: parseInt(settings.value.rollOnly || "0") || null,
    winGuarantee: !!(settings.value.winGuarantee || false) || null,
    unlimitedHistoryScroll: settings.value.unlimitedHistoryScroll,
    showBannerPity: settings.value.showBannerPity,
  };
  $store.commit("updateSettings", newSettings);
  emit("exit");
}

function resetAndRefresh() {
  if (!showConfirmReset.value) {
    showConfirmReset.value = true;
    return;
  }
  $store.commit("resetData");
  window.location.reload();
}

function updateActiveBanners(selected: string[]) {
  console.log("NEW BANNERS", selected);
  $store.commit("updateActiveBanners", selected);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "header",
      onKeyup: _withKeys(exit, ["esc"])
    }, [
      _createElementVNode("img", {
        src: _imports_0,
        class: "exit-button",
        onClick: exit
      })
    ], 40, _hoisted_1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((settings.value.infinitePrimos) = $event)),
          type: "checkbox",
          class: "checkbox"
        }, null, 512), [
          [_vModelCheckbox, settings.value.infinitePrimos]
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((settings.value.rollOnly) = $event)),
          class: "combobox"
        }, _hoisted_10, 512), [
          [_vModelSelect, settings.value.rollOnly]
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((settings.value.winGuarantee) = $event)),
          class: "combobox"
        }, _hoisted_16, 512), [
          [_vModelSelect, settings.value.winGuarantee]
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _hoisted_18,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((settings.value.unlimitedHistoryScroll) = $event)),
          type: "checkbox",
          class: "checkbox"
        }, null, 512), [
          [_vModelCheckbox, settings.value.unlimitedHistoryScroll]
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _hoisted_20,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((settings.value.showBannerPity) = $event)),
          type: "checkbox",
          class: "checkbox"
        }, null, 512), [
          [_vModelCheckbox, settings.value.showBannerPity]
        ])
      ]),
      _createElementVNode("div", _hoisted_21, [
        _hoisted_22,
        _createElementVNode("a", {
          href: _unref(paimonExportJson),
          download: "paimon.json"
        }, "Download", 8, _hoisted_23)
      ]),
      _createElementVNode("div", _hoisted_24, [
        _hoisted_25,
        _createVNode(MultiSelect, {
          options: _unref(bannerOptions),
          selected: _unref($store).state.activeBanners,
          onUpdateSelected: updateActiveBanners
        }, null, 8, ["options", "selected"])
      ]),
      _createElementVNode("div", _hoisted_26, [
        _createVNode(CancelConfirmButton, {
          text: showConfirmReset.value ? 'Confirm reset' : 'Reset all data',
          onPressed: resetAndRefresh
        }, null, 8, ["text"])
      ])
    ])
  ], 64))
}
}

})